/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPipeSlash: {
  name: 'pipe-slash';
  data: string;
} = {
  name: 'pipe-slash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.354 1.646a.5.5 0 1 0-.708.708l12 12a.5.5 0 0 0 .708-.708l-12-12ZM1.5 4a.5.5 0 0 0-1 0v8a.5.5 0 0 0 1 0v-.5h7a.5.5 0 0 0 0-1h-7v-5h1a.5.5 0 0 0 0-1h-1V4Zm14 0a.5.5 0 0 0-1 0v.5h-7a.5.5 0 0 0 0 1h7v5h-1a.5.5 0 0 0 0 1h1v.5a.5.5 0 0 0 1 0V4Z" fill="currentColor"/></svg>`,
};
